import { createSelector } from 'reselect'

import { selectAssortmentState } from './selectAssortmentState'

export const selectAssortmentIsCollapse = createSelector([selectAssortmentState], (state) => {
  return state.isCollapsed
})
